import React from "react";
import ECLTableCell from "./ECLTableCell";
import { translate } from "../../../../utilities/Translate";
import ECLThemeImage from "../../ECLThemeImage/ECLThemeImage";
import ECLDropDown from "../../ECLDropDown/ECLDropDown";
import ECLCheckBox from "../../../ECLInputs/ECLCheckBox/ECLCheckBox";

export default function BodyColumns({
   row,
   index,
   tableSettings,
   columnSettings,
   instanceId,
   selection = null,
   style = null,
}) {
   return (
      <div
         role="row"
         aria-rowindex={index}
         className={
            "ecl-table-row" +
            (index % 2 !== 0 ? " table-alt-row" : "") +
            (tableSettings.hoverIndicator ? " table-row-hover" : "")
         }
         style={
            style
               ? { ...style, display: "flex" }
               : {
                    display: "flex",
                    height: tableSettings.rowHeight + "px",
                 }
         }
      >
         {selection && !tableSettings.stickySelections && (
            <div
               role="cell"
               className="ecl-table-cell"
               style={{
                  width: "45px",
                  minWidth: "45px",
               }}
            >
               <ECLCheckBox
                  defaultChecked={row.selected}
                  id={"table-select-" + instanceId + index}
                  onClick={(e) => {
                     tableSettings.selectAction(index, e.target.checked);
                  }}
               />
            </div>
         )}
         {tableSettings.columnOrder.map((key, i) => {
            const columnIndex = columnSettings.findIndex((c) => c.id === key);
            return (
               <ECLTableCell
                  columnSettings={columnSettings}
                  tableIndex={index}
                  columnInfo={columnSettings[columnIndex]}
                  hide={
                     tableSettings.columnHide
                        ? tableSettings.columnHide.includes(key)
                        : false
                  }
                  content={row.row[columnIndex]}
                  key={key + index + i}
               />
            );
         })}
         {tableSettings.rowActions && !tableSettings.stickyRowActions && (
            <div
               role="cell"
               className="ecl-table-cell button-cell"
               style={{
                  width: "45px",
                  minWidth: "45px",
               }}
            >
               <ECLDropDown
                  containerId={"table-container-" + instanceId}
                  menuWidth={250}
                  trigger={
                     <ECLThemeImage
                        alt={translate("Row action trigger")}
                        className="default-trigger-image"
                        fontAwesome="ellipsis-vertical"
                     />
                  }
               >
                  {tableSettings.rowActionsConstraint &&
                  tableSettings.rowActionsConstraint(index) === false ? (
                     <p>{tableSettings.rowActionsFallback}</p>
                  ) : (
                     tableSettings.rowActions.map((r, i) => {
                        if (
                           r.constraint !== undefined &&
                           r.constraint(index) === false
                        ) {
                           return null;
                        }
                        return (
                           <button
                              key={r + i}
                              style={{
                                 width: "200px",
                              }}
                              onClick={(e) => {
                                 e.preventDefault();
                                 r.action(index);
                              }}
                           >
                              {translate(r.label)}
                           </button>
                        );
                     })
                  )}
               </ECLDropDown>
            </div>
         )}
      </div>
   );
}
